
import { supabase } from "@/integrations/supabase/client";
import { Lead } from "@/types";
import { MOCK_DEALER_ID } from "./constants";

// Function to check for duplicate leads by email or phone
export const checkDuplicateLead = async (email: string, phone: string): Promise<Lead | null> => {
  try {
    console.log("Checking for duplicates with email or phone:", email, phone);
    const { data, error } = await supabase
      .from('leads')
      .select('*')
      .or(`email.eq.${email},phone.eq.${phone}`)
      .eq('dealer_id', MOCK_DEALER_ID)
      .limit(1);
    
    if (error) {
      console.error("Error checking for duplicates:", error);
      throw new Error(`Supabase error: ${error.message} (code: ${error.code})`);
    }
    
    if (data && data.length > 0) {
      console.log("Found duplicate lead:", data[0]);
      return data[0];
    }
    
    return null;
  } catch (error) {
    console.error("Error in checkDuplicateLead:", error);
    return null;
  }
};
